import Searchbox from "./searchbox";
import Breadcrumb from "components/shared/breadcrumb";
import { memo, useEffect, useState } from "react";
import Checkbox from "components/shared/inputs/checkbox";
import Pagination from "components/shared/pagination";
import Skeleton from "components/skeleton/table-1";
import { Link, useLocation } from "react-router-dom";
import BottomSkeleton from "components/skeleton/table-grid-bottom";
import BreadcrumbSkeleton from "components/skeleton/breadcrumb-1";
import { faNumToEng, generateIconLink, toMoneyFormat } from "utils";
import convertUtils from "utils/convert-utils";
import PriorityModal from "./priorityModal";
import { paymentStatuses } from "constants/statuses";
import UseFetch from "hooks/useFetch";
import Modal from "components/shared/modal";
import { toast } from "react-toastify";
import MasterAPI from "service/master";

const List = props => {
    const {
        pageData,
        setServerBreadcrumbDataCallback,
        serverBreadcrumb
    } = props;

    const location = useLocation();
    const urlParams = new URLSearchParams(location.search);

    const [fetchUrl, setFetchUrl] = useState(null);
    const [urlParamsData, setUrlParamsData] = useState({});
    const [selectedRows, setSelectedRows] = useState([]);
    const [priorityData, setPriorityData] = useState({ show: false });
    const { isLoading, data, error, mutate } = UseFetch(fetchUrl);
    const { isLoading: blocksLoading, data: blocksData, error: blocksError } = UseFetch("/api/financial/summary");
    const [showAddModal, setShowAddModal] = useState(false);
    const [amount, setAmount] = useState("");
    const [amountLoading, setAmountLoading] = useState(false);

    useEffect(() => {
        if (!pageData)
            return;

        let newFetchUrl = pageData.index_url;
        let newUrlParams = [];
        let newUrlParamsData = {};

        pageData.search_valid_params.forEach(param => {
            const paramValue = urlParams.get(param);
            if (paramValue) {
                newUrlParamsData[param] = paramValue;
                newUrlParams.push(`${param}=${paramValue}`);
            }
        })

        if (Object.keys(newUrlParamsData).length) {
            newFetchUrl += `?${newUrlParams.join("&")}`;
            setUrlParamsData(newUrlParamsData);
        } else
            setUrlParamsData({});

        setFetchUrl(newFetchUrl);
        // eslint-disable-next-line
    }, [pageData, location.search])

    useEffect(() => {
        if (data && data.breadcrumbs?.length)
            setServerBreadcrumbDataCallback(data.breadcrumbs);
        else
            setServerBreadcrumbDataCallback([]);

        // eslint-disable-next-line
    }, [data])

    const selectRowHandler = id => {
        setSelectedRows(prev => {
            if (selectedRows.indexOf(id) !== -1) {
                const newState = prev.filter(rowId => rowId !== id);
                return newState;
            }

            return [...prev, id];
        })
    }

    const createOrEditLink = id => {
        let url = location.pathname;

        if (id)
            url += `/${id}`;

        const validParams = [];
        if (pageData && pageData.add_valid_params) {
            pageData.add_valid_params.forEach(param => {
                const paramValue = urlParams.get(param);
                if (paramValue)
                    validParams.push(`${param}=${paramValue}`);
            })
        }

        if (validParams.length)
            url += `?${validParams.join("&")}`;

        return url;
    }

    const amountChangeHandler = e => {
        let newVal = e.target.value;
        newVal = faNumToEng(newVal);
        newVal = newVal.replaceAll(",", "");

        if (newVal === "")
            setAmount(newVal);
        else if (/^[0-9\b]+$/.test(newVal)) {
            setAmount(toMoneyFormat(parseInt(newVal)));
        }
    }

    const amountSubmitHandler = async e => {
        e.preventDefault();

        if (amountLoading)
            return;

        if (amount.length === 0) {
            toast.error("مبلغ مورد نظر را وارد نمایید");
            return;
        }

        setAmountLoading(true);
        try {
            const res = await MasterAPI({
                url: "/api/financial/balance/withdraw",
                payloadType: 3,
                data: {
                    amount: parseInt(amount.replaceAll(",", ""))
                },
                callback: () => setAmountLoading(false)
            });

            toast.success(res.message);
            setShowAddModal(false);
            setAmount("");
            mutate();
        } catch (e) {
            toast.error(e.message);
        }
    }

    return (
        <>
            <div className="flex item-start md:items-center justify-start md:justify-between flex-col md:flex-row mb-10">
                <div className="mb-6 md:mb-0">
                    <h1 className="title-c1 tp-21">{pageData.title}</h1>
                    {
                        !isLoading ? (
                            serverBreadcrumb.length
                                ? <Breadcrumb data={serverBreadcrumb} />
                                : <Breadcrumb data={pageData.breadcrumb} />
                        ) : (
                            <BreadcrumbSkeleton />
                        )
                    }
                </div>

                <div className="flex">
                    <button className="w-10 h-10 tp-22 text-[#424e79] dark:text-white ml-3 rounded-md fit-center" onClick={mutate} title="بروزرسانی">
                        <i className="fa-regular fa-arrows-retweet"></i>
                    </button>
                </div>
            </div>

            {
                !blocksError && (
                    <div className="grid md:grid-cols-3 gap-4 mb-5">
                        <div className="bg-white dark:bg-[#0E0E23] border border-gray-300 dark:border-slate-800 rounded-md overflow-hidden text-gray-800 dark:text-slate-200">
                            <div className="bg-gray-100 dark:bg-slate-900 dark:border-slate-800 p-3 border-b border-gray-300">
                                <span className="text-sm">کل مبالغ تسویه شده</span>
                            </div>

                            <div className="text-center p-3 text-sm">
                                {
                                    !blocksLoading ? (
                                        <b>0 تومان</b>
                                    ) : (
                                        <i className="fa-solid fa-spinner spin"></i>
                                    )
                                }
                            </div>
                        </div>

                        <div className="bg-white dark:bg-[#0E0E23] border border-gray-300 dark:border-slate-800 rounded-md overflow-hidden text-gray-800 dark:text-slate-200">
                            <div className="bg-green-300 dark:bg-slate-900 dark:border-slate-800 p-3 border-b border-gray-300">
                                <span className="text-sm">کیف پول</span>
                            </div>

                            <div className="text-center p-3 text-sm">
                                <div className="border-b border-gray-300 dark:border-slate-800 py-3">
                                    {
                                        !blocksLoading ? (
                                            <b>موجودی: {toMoneyFormat(blocksData?.data?.wallet?.balance)} تومان</b>
                                        ) : (
                                            <i className="fa-solid fa-spinner spin"></i>
                                        )
                                    }
                                </div>

                                <div className="py-3">
                                    {
                                        !blocksLoading ? (
                                            <b>موجودی قابل برداشت: {toMoneyFormat(blocksData?.data?.wallet?.withdrawble_balance)} تومان</b>
                                        ) : (
                                            <i className="fa-solid fa-spinner spin"></i>
                                        )
                                    }
                                </div>
                            </div>
                        </div>

                        <div className="bg-white dark:bg-[#0E0E23] border border-gray-300 dark:border-slate-800 rounded-md overflow-hidden text-gray-800 dark:text-slate-200">
                            <div className="bg-gray-100 dark:bg-slate-900 dark:border-slate-800 p-3 border-b border-gray-300">
                                <span className="text-sm">وضعیت سفارش ها</span>
                            </div>

                            <div className="text-right p-3 text-sm">
                                {
                                    paymentStatuses.map(status => (
                                        !!blocksData?.data?.status[status.id] && (
                                            <div>
                                                {status.title}: <b>{blocksData?.data?.status[status.id]}</b>
                                            </div>
                                        )
                                    ))
                                }
                            </div>
                        </div>
                    </div>
                )
            }

            <div className="wrap-box tp-22">
                <div className="flex justify-between items-start">
                    <Searchbox fields={pageData.search_setting} />

                    <button
                        className={`bg-primary-100 hover:bg-primary-200 px-7 transition-colors text-white rounded-md fit-center text-sm h-10 relative overflow-hidden`}
                        onClick={() => setShowAddModal(true)}
                    >
                        <i className="fa-light fa-square-plus ml-2"></i>
                        افزودن
                    </button>
                </div>

                <div className="table-c1 mt-10 mb-4">
                    <table>
                        <thead>
                            <tr>
                                <th className="w-5"></th>
                                <th className="w-5"></th>
                                <th className="w-5"></th>
                                <th></th>
                                <th className="w-5"></th>
                            </tr>
                        </thead>

                        <tbody>
                            {isLoading && <Skeleton />}
                        </tbody>
                    </table>

                    {
                        isLoading || (data && data.data?.length) ? (
                            <table>
                                <thead>
                                    <tr>
                                        <th className="w-5"></th>
                                        <th className="w-5"></th>
                                        <th className="w-5"></th>
                                        <th></th>
                                    </tr>
                                </thead>

                                <tbody>
                                    {
                                        !isLoading ? (
                                            data.data?.map((item, i) => {
                                                const hasIcon = pageData.index_setting.icon?.length > 0;
                                                const labels = [];
                                                ["label_1", "label_2", "label_3"].forEach(label => {
                                                    const labelObj = pageData.index_setting[label];

                                                    if (labelObj) {
                                                        const intendedKey = labelObj.key;
                                                        let value = item[intendedKey] || "-";

                                                        if (labelObj.convert_function)
                                                            value = convertUtils(labelObj.convert_function, value);

                                                        labels.push(`${labelObj.label}: ${value}`);
                                                    }
                                                })

                                                return (
                                                    <tr key={`table-row-${i}`}>
                                                        <td>
                                                            <Checkbox
                                                                value={selectedRows.indexOf(item.id) !== -1}
                                                                changeHandler={() => selectRowHandler(item.id)}
                                                            />
                                                        </td>

                                                        <td>
                                                            {
                                                                item.status_id === 0 && <i className="fa-regular fa-hourglass-start deactive" title="در انتظار تایید"></i>
                                                            }

                                                            {
                                                                item.status_id === 1 && <i className="fa-solid fa-check status active" title="تایید شده"></i>
                                                            }

                                                            {
                                                                item.status_id === 2 && <i className="fa-solid fa-xmark status deactive" title="رد شده"></i>
                                                            }
                                                        </td>

                                                        <td>
                                                            <Link className="edit" to={createOrEditLink(item.id)}>
                                                                <i className="fa-regular fa-eye"></i>
                                                            </Link>
                                                        </td>

                                                        <td className={`desc-col${hasIcon ? " has-icn" : ""}`}>
                                                            {
                                                                hasIcon && (
                                                                    <div className="icn-holder-c1">
                                                                        {
                                                                            pageData.index_setting.icon.map((icon, i) => {
                                                                                const className = {};

                                                                                if (icon.class)
                                                                                    className.className = icon.class;

                                                                                return (
                                                                                    <Link
                                                                                        key={`${i}-icon-${i}`}
                                                                                        to={generateIconLink(item, icon.url)}
                                                                                        title={icon.title}
                                                                                        {...className}
                                                                                    >
                                                                                        <i className={icon.font_icon} />
                                                                                    </Link>
                                                                                )
                                                                            })
                                                                        }
                                                                    </div>
                                                                )
                                                            }

                                                            <div className={`content${hasIcon ? " grow" : ""}`}>
                                                                <p className="tp-25">
                                                                    <b>{toMoneyFormat(item.amount)}</b> تومان
                                                                </p>

                                                                <h6 className="tp-26">
                                                                    {
                                                                        labels.join(" | ")
                                                                    }
                                                                </h6>

                                                                {
                                                                    pageData.index_setting.recursive && <Link to={`?parent_id=${item.id}`} className="pos-cover"></Link>
                                                                }
                                                            </div>
                                                        </td>
                                                    </tr>
                                                )
                                            })
                                        ) : <Skeleton />
                                    }
                                </tbody>
                            </table>
                        ) : (
                            <></>
                        )
                    }

                    {
                        !isLoading && data && !data.data?.length && (
                            <p className="font-medium text-sm text-center mb-10 text-slate-800 dark:text-gray-300">
                                اطلاعاتی برای نمایش یافت نشد
                            </p>
                        )
                    }

                    {
                        error && <p className="font-medium text-sm text-red-500 text-center">خطا در دریافت اطلاعات!</p>
                    }
                </div>

                {
                    isLoading && (
                        <BottomSkeleton />
                    )
                }

                {
                    data && (
                        <div className="flex justify-between items-center">
                            <span className="text-[#1d212f] dark:text-[#bdbdca] text-sm font-medium">
                                {data.count} مورد - {Math.ceil(data.count / (urlParamsData.limit || 10))} صفحه
                            </span>

                            {
                                !!data.data?.length && (
                                    <Pagination
                                        count={data.count}
                                        limit={urlParamsData.limit}
                                        offset={urlParamsData.offset}
                                    />
                                )
                            }
                        </div>
                    )
                }
            </div>

            <PriorityModal
                data={priorityData}
                setData={setPriorityData}
                submitUrl={pageData.set_url}
                reload={mutate}
            />

            <Modal show={showAddModal} closeHandler={() => setShowAddModal(false)} title="اضافه کردن">
                <div className="px-1 py-3">
                    <form onSubmit={amountSubmitHandler}>
                        <div className={`text-field${amount.length ? " has-val" : ""}`}>
                            <label htmlFor={`checkout_amount`}>مقدار</label>

                            <input
                                type="text"
                                id={`checkout_amount`}
                                value={amount}
                                onChange={amountChangeHandler}
                            />
                        </div>

                        <button className="w-full bg-primary-100 text-white rounded-full py-2 mt-4">
                            {amountLoading ? <i className="fa-solid fa-spinner spin"></i> : "ثبت"}
                        </button>
                    </form>
                </div>
            </Modal>
        </>
    )
}

export default memo(List);